import { AddComponent } from './pages/add/add.component';
import { ViewComponent } from './pages/view/view.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListingComponent } from './pages/listing/listing.component';
import { BidsListingComponent } from './pages/bids-listing/bids-listing.component';
import { GetSecondHandSupplyByPkResolver } from './resolvers/get-second-hand-supply-by-pk.resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full'
  },
  {
    path: 'list/:status',
    component: ListingComponent
  },
  {
    path: 'list',
    component: ListingComponent
  },
  {
    path: 'add',
    component: AddComponent
  },{
    path: 'edit/:id',
    component: AddComponent,
    resolve:{
      oldSecondHandSupply: GetSecondHandSupplyByPkResolver
    }
  },
  {
    path: 'view/:id',
    component: ViewComponent,
    resolve:{
      oldSecondHandSupply: GetSecondHandSupplyByPkResolver
    }
  },
  {
    path: 'bids/:id',
    component: BidsListingComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreOwnedSuppliesRoutingModule { }
